import React from 'react'
import { Link } from 'react-router-dom'
import t from '../../service/translate.service'
import PropTypes from 'prop-types'
import LoadingPageOverlay from '../../components/LoadingPageOverlay'
import { Alert } from 'antd'

export const LettersUnregister = ({
   onHandleConfirm,
   onHandleCancel,
   loading,
   error
}) => {

  return (
    <div className='wrapper heating-energy-modal' role="dialog" aria-labelledby="unregister-title" aria-describedby="unregister-description">
      {loading && <LoadingPageOverlay />}
      <div id="unregister-description" className='description'>{t.LETTERS_UNREGISTRATION_TEXT}</div>
      {error && (
        <Alert
          message={error}
          type='error'
          style={{ marginBottom: '12px', marginTop: '12px' }}
          role="alert"
          aria-live="assertive"
        />
      )}
      <div className='btns-holder'>
        <Link
          to=''
          className='button primary'
          onClick={() => onHandleConfirm()}
          role="button"
          aria-label={t.LOYALTY_SUBMIT_CODE}
        >
          {t.LOYALTY_SUBMIT_CODE}
        </Link>
        <Link
          to=''
          className='button tertiary'
          onClick={() => onHandleCancel()}
          role="button"
          aria-label={t.HEATING_AND_ENERGY_CANCEL}
        >
          {t.HEATING_AND_ENERGY_CANCEL}
        </Link>
      </div>
    </div>
  );
}
LettersUnregister.propTypes = {
    onHandleConfirm: PropTypes.func,
    setLettersUnregiser: PropTypes.bool,
    onHandleCancel: PropTypes.func
}